import axiosInstance from "@/api/axiosInstance";
import axiosInstanceForBlob from "./axiosInstanceForBlob";
import { UpdateVisualizationAccessPayload } from "@/common/types";

export const getQuestionnaireListApi = (
  page: number = 1,
  doctor: string = "",
  patient: string = ""
) => {
  let url = `/questionnaires/?page=${page}`;
  if (patient !== "") {
    url = url + `&patient=${patient}`;
  }
  if (doctor !== "") {
    url = url + `&doctor=${doctor}`;
  }
  const response = axiosInstance.get(url);
  return response;
};

export const getQuestionnaireDetailApi = (id: number) => {
  const response = axiosInstance.get(`/questionnaires/${id}`);
  return response;
};

export const getQuestionnaireDetailByTestKitApi = (id: number) => {
  const response = axiosInstance.get(`/questionnaires/test-kit/${id}/`);
  return response;
};

export const downloadQuestionnaireCsvApi = (id: number) => {
  const response = axiosInstanceForBlob.get(`/questionnaires/export/${id}`);
  return response;
};

export const updateVisualizationAccessApi = (
  payload: UpdateVisualizationAccessPayload
) => {
  const response = axiosInstance.post(
    `/doctors/visualization-access/`,
    payload
  );
  return response;
};
